// extracted by mini-css-extract-plugin
export default {"picker":"OwnerPicker_picker__bgTiZ","chip":"OwnerPicker_chip__2hHKH","chipOn":"OwnerPicker_chipOn__rxFKf","chipTeam":"OwnerPicker_chipTeam__LU9pO"};